import React, { useState, useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { color } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { useSelector } from 'react-redux';
import translations from 'translations';
import SelectorChart from './selector-chart';
import ListChart from './list-chart';

const Wrapper = styled.div`
  ${color}

  display: flex;
  flex-direction: row;
  padding: ${themeGet('space.l')}px;
  border: 2px solid ${themeGet('colors.primary_100')};
  box-sizing: border-box;
  border-radius: 12px;
  height: 100%;

  & > .left {
    margin-right: ${themeGet('space.xxl')}px;
  }

  & > .right {
    flex: 1;
  }
`;

function TopLineCharts({
  compare,
  dataType,
  dateFrom,
  dateTo,
  dateRange,
  filters,
  terms,
  color = 'store_name',
  topList,
  reloadChecked,
  isAdmin,
}) {
  const [selected, setSelected] = useState(0);
  const { languageCode } = useSelector((state) => state.config);
  const [queryFilters, setQueryFilters] = useState(filters);

  let termsList = [];
  if (topList === 'partners') {
    termsList = [
      { label: 'Amazon', value: 'store_id=44' },
      { label: 'Kobo', value: 'store_id=58' },
      { label: 'Tolino', value: 'store_id=162' },
      { label: 'Libreka', value: 'store_id=125' },
    ];
  } else {
    termsList = [
      { label: translations[languageCode].Channels, value: 'store_name' },
      { label: translations[languageCode].Titles, value: 'title' },
      { label: translations[languageCode].Categories, value: `main_category.${languageCode}` },
      { label: translations[languageCode].Authors, value: 'authors' },
      { label: translations[languageCode].Languages, value: `language.${languageCode}` },
      { label: translations[languageCode].Publishers, value: 'publisher' },
      { label: translations[languageCode].Collections, value: 'collections' },
      { label: translations[languageCode].country, value: `country.${languageCode}` },
    ];
  }

  if (dataType === 'usage_data') termsList = termsList.filter((term) => term.value !== 'title');

  const handleChange = useCallback((v) => {
    setSelected(v);
  }, []);

  useEffect(() => {
    if (topList !== 'partners') return setQueryFilters(filters);
    if (filters.match(/store_id/)) return setQueryFilters(filters);
    const f = `${filters}${filters ? ',' : ''}${termsList[selected].value}`;
    setQueryFilters(f);
  }, [selected, filters, termsList, topList]);

  return (
    <Wrapper bg="white">
      <div className="left">
        <SelectorChart
          payload={termsList}
          onChange={handleChange}
          selected={selected}
          disabled={filters.match(/store_id/) && topList === 'partners'}
        />
      </div>

      <div className="right">
        <ListChart
          color={color}
          term={topList === 'partners' ? 'store_partner_name' : termsList[selected].value}
          dataType={dataType}
          dateFrom={dateFrom}
          dateRange={dateRange}
          dateTo={dateTo}
          compare={compare}
          filters={queryFilters}
          terms={terms}
          reloadChecked={reloadChecked}
          topList={topList}
          isAdmin={isAdmin}
        />
      </div>
    </Wrapper>
  );
}

export default TopLineCharts;
